<template>
  <div class="student-insurance">
    <div class="ly-card hd">
      <el-select v-model="searchFormData.year" placeholder="学年">
        <el-option v-for="item in years" :key="item.value" :label="item.label" :value="item.value"> </el-option>
      </el-select>
      <el-select v-model="searchFormData.term" placeholder="学期">
        <el-option  :key="-1" label="全部" :value="-1"> </el-option>
        <el-option v-for="item in terms" :key="item.value" :label="item.label" :value="item.value"> </el-option>
      </el-select>
      <remote-search :options="org_id" @input="value => change('org_id', value)" :isCache="true" />
      <remote-search
        :options="specialized_subject_id"
        ref="spec"
        @input="value => change('specialized_subject_id', value)"
        :isCache="true"
      />
      <remote-search :options="class_id" ref="classId" @input="value => change('class_id', value)" :isCache="true" />
      <el-button @click="search">查询</el-button>
      <el-button type="primary" @click="exportExcel">导出</el-button>
    </div>
    <ly-table
      :getTableData="getTableData"
      :tableHeader="tableHeader"
      :searchFormData="searchFormData"
      :tableConfig="tableConfig"
      class="ly-card"
      ref="lyTable"
    >
      <template v-slot:rocking_success_rate="row">
        {{ ((row.rocking_success_rate || 0) * 100).toFixed(2) }} %
      </template>
    </ly-table>
  </div>
</template>
<script>
import { Select, Option } from 'element-ui';

import LyTable from '@/components/LyTable';
import RemoteSearch from '@/components/common/RemoteSearch';
import { contact } from '@/api';
import { studentInscTable } from '@/utils/tableHeader';
import { specialized_subject_id, class_id_query, org_id } from '@/utils/formConfigCommon';
import utils from '@/utils/utils';

export default {
  name: 'studentInsurance',
  components: { ElSelect: Select, ElOption: Option, RemoteSearch, LyTable },
  data() {
    return {
      specialized_subject_id: {
        ...specialized_subject_id.options,
        key: 'specialized_subject_id',
        multiple: true,
        placeholder: '项目检索'
      },
      org_id: {
        ...org_id.options,
        key: 'org_id',
        clearable: true,
        placeholder: '部门检索'
      },
      class_id: {
        ...class_id_query.options,
        multiple: false,
        key: 'class_id',
        clearable: true,
        placeholder: '班级检索'
      },
      searchFormData: {
        org_id: '',
        year: new Date().getFullYear(),
        term: '',
        class_id: '',
        specialized_subject_ids: ''
      },
      tableConfig: {
        border: true
      },
      tableHeader: studentInscTable,
      getTableData: contact.getStudentInsurance,
      terms: [],
      years: []
    };
  },
  mounted() {
    this.$store.dispatch('schoolYear/getTermAndYearList').then(data => {
      if (data) {
        this.years = data.year;
        this.terms = data.term;
        this.searchFormData.term = data.term[0].value;
        this.search();
      }
    });
  },
  computed: {
    label() {
      return value => {
        if (value) return this.terms.find(item => item.value === value).label;
        return '';
      };
    }
  },
  methods: {
    change(key, value) {
      this.searchFormData[key] = value;
    },
    search() {
      this.$refs.lyTable.setData();
    },
    exportExcel() {
      const params = { ...this.searchFormData };
      Object.keys(params).forEach(key => {
        if (params[key] === '' || params[key] === null || params[key] === -1) delete params[key];
      });
      contact
        .exportStudentInsurance({
          params
        })
        .then(data => {
          if (data) utils.downloadData(data, '学员保险');
        });
    }
  }
};
</script>
<style lang="less">
.student-insurance {
  .hd {
    .el-select {
      width: 100px;
    }
    .ly-search-comp {
      display: inline-block;
      width: 200px;
      .el-select {
        width: 100%;
      }
      .el-input {
        width: 100%;
      }
    }
    > * {
      margin: 0 10px;
    }
  }
}
</style>
